import { InventoryConstant } from "../constants/inventory.constant";

const initialState = {
    inventoryProductList: [],
    inventoryProductListStatus: '',
    productDetails: {},
    consignmentStatus: '',
    consignmentData: {},
    activeIntegrations: [],
    activeIntegrationsStatus: '',
    consignmentTypes: [],
    consignmentAllStatus: [],
    warehouseList: [],
    productHistory: [],
    productHistoryStatus: '',
    inboundHistory: [],
    inboundHistoryStatus: '',
    consignmentElementStatus: [],
    marketPlacesList: [],
    warehouseListBySellerId: [],
    incomingProductHistory: [],
    incomingIroductHistoryStatus: '',
    allMarketPlaces: [],
    bulkReturnList: [],
    bulkReturnListStatus: '',
};
export default function InventoryReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case InventoryConstant.INVENTORY_PRODUCT_LISTING_PENDING:
            return {
                ...state,
                inventoryProductList: [],
                inventoryProductListStatus: 'pending'
            };
        case InventoryConstant.INVENTORY_PRODUCT_LISTING_SUCCESS:
            return {
                ...state,
                inventoryProductList: payload,
                inventoryProductListStatus: 'success'
            };
        case InventoryConstant.INVENTORY_PRODUCT_LISTING_FAILED:
            return {
                ...state,
                inventoryProductList: [],
                inventoryProductListStatus: 'failed'
            };
        case InventoryConstant.GET_BY_PRODUCT_ID_PENDING:
            return {
                ...state,
                productDetails: {},
                productDetailsStatus: 'pending'
            };
        case InventoryConstant.GET_BY_PRODUCT_ID_SUCCESS:
            return {
                ...state,
                productDetails: payload,
                productDetailsStatus: 'success'
            };
        case InventoryConstant.GET_BY_PRODUCT_ID_FAILED:
            return {
                ...state,
                productDetails: {},
                productDetailsStatus: 'failed'
            };
        case InventoryConstant.GET_CONSIGNMENT_PENDING:
            return {
                ...state,
                consignmentData: {},
                consignmentStatus: 'pending'
            };
        case InventoryConstant.GET_CONSIGNMENT_SUCCESS:
            return {
                ...state,
                consignmentData: payload,
                consignmentStatus: 'success'
            };
        case InventoryConstant.GET_CONSIGNMENT_FAILED:
            return {
                ...state,
                consignmentData: {},
                consignmentStatus: 'failed'
            };
        case InventoryConstant.GET_ACTIVEINTEGRATION_PENDING:
        case InventoryConstant.GET_ACTIVEINTEGRATION_SUCCESS:
        case InventoryConstant.GET_ACTIVEINTEGRATION_FAILED: {
            let activeIntegrations = [];
            let activeIntegrationsStatus = 'failed';

            if (type === InventoryConstant.GET_ACTIVEINTEGRATION_PENDING) {
                activeIntegrationsStatus = 'pending';
            } else if (type === InventoryConstant.GET_ACTIVEINTEGRATION_SUCCESS) {
                activeIntegrations = payload;
                activeIntegrationsStatus = 'success';
            }

            return {
                ...state,
                activeIntegrations,
                activeIntegrationsStatus,
            };
        }
        case InventoryConstant.GET_ALL_CONSIGNMENT_TYPE_SUCCESS:
            return {
                ...state,
                consignmentTypes: payload
            };
        case InventoryConstant.GET_ALL_CONSIGNMENT_STATUS_SUCCESS:
            return {
                ...state,
                consignmentAllStatus: payload
            };
        case InventoryConstant.GET_ALL_WAREHOUSE_LIST_SUCCESS:
            return {
                ...state,
                warehouseList: payload
            };
        case InventoryConstant.EMPTYPRODUCT_DETAILS:
            return {
                ...state,
                productDetails: {},
                productDetailsStatus: ''
            };
        case InventoryConstant.INVENTORY_PRODUCT_HISTORY_PENDING:
            return {
                ...state,
                productHistory: [],
                productHistoryStatus: 'PENDING'
            };
        case InventoryConstant.INVENTORY_PRODUCT_HISTORY_SUCCESS:
            return {
                ...state,
                productHistory: payload,
                productHistoryStatus: 'SUCCESS'
            };
        case InventoryConstant.INVENTORY_PRODUCT_HISTORY_FAILED:
            return {
                ...state,
                productHistory: [],
                productHistoryStatus: 'FAILED'
            };
        case InventoryConstant.INVENTORY_INBOUND_HISTORY_PENDING:
            return {
                ...state,
                inboundHistory: [],
                inboundHistoryStatus: 'PENDING'
            };
        case InventoryConstant.INVENTORY_INBOUND_HISTORY_SUCCESS:
            return {
                ...state,
                inboundHistory: payload,
                inboundHistoryStatus: 'SUCCESS'
            };
        case InventoryConstant.INVENTORY_INBOUND_HISTORY_FAILED:
            return {
                ...state,
                inboundHistory: [],
                inboundHistoryStatus: 'FAILED'
            };
        case InventoryConstant.INVENTORY_PRODUCT_INVENTORY_PENDING:
            return {
                ...state,
                inventoryHistory: [],
                inventoryHistoryStatus: "PENDING",
            };
        case InventoryConstant.INVENTORY_PRODUCT_INVENTORY_SUCCESS:
            return {
                ...state,
                inventoryHistory: payload,
                inventoryHistoryStatus: "SUCCESS",
            };
        case InventoryConstant.INVENTORY_PRODUCT_INVENTORY_FAILED:
            return {
                ...state,
                inventoryHistory: [],
                inventoryHistoryStatus: "FAILED",
            };
        case InventoryConstant.GET_ALL_CONSIGNMENT_STATUS_LIST_SUCCESS:
            return {
                ...state,
                consignmentElementStatus: payload
            };
        case InventoryConstant.FETCH_ALL_MARKETPLACES:
            return {
                ...state,
                marketPlacesList: payload
            };
        case InventoryConstant.GET_WAREHOUSE_BY_SELLER_ID_SUCCESS:
            return {
                ...state,
                warehouseListBySellerId: payload
            };
        case InventoryConstant.INVENTORY_INCOMING_HISTORY_PENDING:
            return {
                ...state,
                incomingProductHistory: [],
                incomingIroductHistoryStatus: 'PENDING'
            };
        case InventoryConstant.INVENTORY_INCOMING_HISTORY_SUCCESS:
            return {
                ...state,
                incomingProductHistory: payload,
                incomingIroductHistoryStatus: 'SUCCESS'
            };
        case InventoryConstant.GET_ALL_MARKETPLACE_SERVICES_SUCCESS:
            return {
                ...state,
                allMarketPlaces: payload,
            };
        // Bulk return list
        case InventoryConstant.GET_BULK_RETURN_LIST_PENDING:
        case InventoryConstant.GET_BULK_RETURN_LIST_SUCCESS:
        case InventoryConstant.GET_BULK_RETURN_LIST_FAILED: {
            const map = {
                [InventoryConstant.GET_BULK_RETURN_LIST_PENDING]: { list: [], status: 'PENDING' },
                [InventoryConstant.GET_BULK_RETURN_LIST_SUCCESS]: { list: payload, status: 'SUCCESS' },
                [InventoryConstant.GET_BULK_RETURN_LIST_FAILED]: { list: [], status: 'FAILED' },
            };
            return {
                ...state,
                bulkReturnList: map[type].list,
                bulkReturnListStatus: map[type].status,
            };
        }
        default:
            return state;
    }
}